module.exports = __webpack_public_path__ + "img/rate-share.bd19b7bf.svg";